import { useMemo } from "react";
import { Col, Layout, Row, Typography } from "antd";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { selectIsAuthenticated } from "@/redux/authentication/selectors.js";
import BaseButton from "@/components_v2/Button/BaseButton.js";
import { BUTTON_TYPES } from "@/components_v2/Button/constants";

const { Title } = Typography;

const MinimalLayout = () => {
  const { Content, Footer } = Layout;
  const location = useLocation();
  const { t } = useTranslation();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const link = useMemo(() => {
    return {
      title: t("layouts.labels.haveAnAccount"),
      to: "/login",
      buttonContent: t("layouts.labels.signIn"),
    };
  }, [location.pathname]);

  if (isAuthenticated && location.pathname.includes("/public")) {
    return (
      <Navigate
        to={location.pathname.replace("/public", "") + location.search}
      />
    );
  }

  return (
    <Layout>
      <Row className="m-3" align="middle" justify="end">
        <Col className="me-3">
          <Title level={5}>{link.title}</Title>
        </Col>
        <Col>
          <BaseButton to={link.to} type={BUTTON_TYPES.LINK}>
            {link.buttonContent}
          </BaseButton>
        </Col>
      </Row>
      <Content className="w-100">
        <Outlet />
      </Content>
      <Footer>
        <Row>
          <Col />
          <Col />
        </Row>
      </Footer>
    </Layout>
  );
};

export default MinimalLayout;
